module.exports = __webpack_public_path__ + "img/IMG_7213.573529b5.webp";